/* global zE */

import pubsub from 'lib/pubsub';
import { getActiveLang } from '@openclassrooms/translations';
import { CurrentUser } from 'Modules/currentUser';
import browser from '@openclassrooms/utils/browser';

let configured = false;
let currentUser;
let identifyFieldsValues = {
  name: '',
  email: '',
  phoneNumber: '',
};

if (CurrentUser.hasCurrentUser()) {
  currentUser = CurrentUser.get();
  identifyFieldsValues = {
    name: currentUser.displayableName,
    email: currentUser.email,
    phone: currentUser.phoneNumber,
  };
}

function configureZendeskWidget(identifyValues) {
  zE('webWidget', 'setLocale', getActiveLang());
  zE('webWidget', 'identify', identifyValues);
  zE('webWidget', 'prefill', {
    name: {
      value: identifyValues.name,
    },
    email: {
      value: identifyValues.email,
    },
    phone: {
      value: identifyValues.phoneNumber,
    },
  });

  zE('webWidget:on', 'close', () => {
    zE('webWidget', 'hide');
  });
}

export default () => {
  if (!configured) {
    configureZendeskWidget(identifyFieldsValues);
    configured = true;
  }

  pubsub.get().publish(pubsub.WANTED_TO_CONTACT_US, { from: browser.document.location.toString() });

  zE('webWidget', 'open');
  zE('webWidget', 'show');
};
